<template>
  <div class="member-sso">正在登录 PG 平台…</div>
</template>

<script>
import HttpApi from '@/services/httpapi.js';
import store from '@/store';

export default {
  name: 'MemberSso',
  async created() {
    const ticket = String(this.$route.query.ticket || '');
    if (!ticket) return this.$router.replace('/');
    try {
      const response = await HttpApi.post('member/sso/login', { ticket });
      if (!response.data || response.data.code !== 200 || !response.data.data.api_token) throw new Error('登录票据无效');
      sessionStorage.setItem('token', response.data.data.api_token);
      store.commit('changToken');
      const user = await HttpApi.post('user', {});
      localStorage.setItem('userInfo', JSON.stringify(user.data && user.data.data ? user.data.data : user.data || {}));
      store.commit('changUserInfo');
      this.$router.replace('/');
    } catch (error) {
      this.$router.replace('/login');
    }
  },
};
</script>

<style scoped>
.member-sso { min-height: 100vh; display: flex; align-items: center; justify-content: center; color: #666; font-size: 16px; }
</style>



// WEBPACK FOOTER //
// src/components/memberSso.vue